import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../infra/hooks";
import { commonServices } from "../../../api/services/commonServices";
import { setLoading } from "../../../infra/aggregates/LoaderSlice";
import { seEmpStatus } from "../../../infra/aggregates/empStatusSlice";

interface PropsValue {
  setEmployeeDetail: (data: any) => void;
  //setEmpStatus?: any;
  empStatusFirstTime?: any;
}

function DTOInnerBarPersonalDetails({
  setEmployeeDetail,
  //setEmpStatus,
  empStatusFirstTime,
}: PropsValue) {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  useEffect(() => {
    // alert("test------------" + selector?.profilePicSlice?.profilePic);
    setEmployeeDetail({
      name:
        selector?.personalInfoSlice?.firstName +
        " " +
        selector?.personalInfoSlice?.lastName,
      designation: selector?.authSlice?.designaion,
      profilePic: selector?.profilePicSlice?.profilePic,
      award: selector.userAwardsSlice.awards,
    });
  }, [
    selector.personalInfoSlice?.firstName,
    selector?.personalInfoSlice?.lastName,
    selector?.authSlice?.designaion,
    /* selector?.profilePicSlice?.profilePic, */
    selector.userAwardsSlice.awards,
  ]);

  async function getCurrentEmpStatus() {
    dispatch(setLoading(true));
    if (selector.authSlice) {
      commonServices
        .getCurrentEmpStatus(
          selector.authSlice.emp_id,
          selector.authSlice.company_id
        )
        .then((res: any) => {
          if (res.response == "success") {
            dispatch(setLoading(false));

            // setEmpStatus(res?.data == 1 ? true : false);
            dispatch(seEmpStatus(res?.data == 1 ? true : false));
          }
        });
    } else {
      dispatch(setLoading(false));
      return;
    }
  }
  useEffect(() => {
    setEmployeeDetail({
      name: selector.personalInfoSlice?.firstName
        ? selector.personalInfoSlice.firstName +
          " " +
          selector.personalInfoSlice.lastName
        : selector?.authSlice?.name,
      designation: selector?.authSlice?.designaion,
      profilePic: selector?.profilePicSlice?.profilePic,
      award: selector.userAwardsSlice.awards,
    });
  }, [selector?.profilePicSlice?.profilePic]);
  useEffect(() => {
    if (empStatusFirstTime) {
      getCurrentEmpStatus();
    }
  }, [empStatusFirstTime]);
  return <></>;
}
export default DTOInnerBarPersonalDetails;
